import en from './en';
import es from './es';
import de from './de';
import sv from './sv';

export default {
  en,
  es,
  de,
  sv,
};
